module.exports = __webpack_public_path__ + "static/media/7.530e4a9a.jpeg";